import type { Profile } from '@here/api'
import { userId } from '@state'
import { createResource, createSignal } from 'solid-js'
import { updateProfile, updateProfilePicture } from './resources'

export function useProfile() {
	const [fileChange, setFileChange] = createSignal<File>()

	const [profile, setProfile] = createSignal<Partial<Profile>>()
	const [profileResource] = createResource(profile, updateProfile)

	const [profilePicture, setprofilePicture] = createSignal<{ file: File; id: string }>()
	const [profilePictureResource] = createResource(profilePicture, updateProfilePicture)

	const uploadProfilePicture = () => {
		setprofilePicture({
			id: userId()!,
			file: fileChange()!,
		})
	}

	return {
		setProfile,
		profile,
		profileResource,
		setprofilePicture,
		profilePictureResource,
		fileChange,
		setFileChange,
		uploadProfilePicture,
	}
}
